<template>
  <container class="mt-8 px-12 py-8">
    <div class="quiz">
      <div>
        <div v-for="i in 5" class="question mb-8">
          <div class="question-head mb-4 flex justify-between font-black">
            <h6>Question {{ i }}</h6>
            <span>5 marks</span>
          </div>
          <div class="mb-4">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Consectetur ut iste dolorum impedit tempore quibusdam assumenda
              voluptate corporis, quas eveniet optio obcaecati soluta beatae
              veritatis voluptatibus voluptatum eligendi hic nulla quasi omnis
              inventore illo commodi tempora? Vel, ab, ratione.
            </p>
          </div>
          <GChart type="PieChart" :data="chartData" :options="chartOptions" />
          <!-- <div class="flex flex-col options">
            <span v-for="x in 4" class="mb-4">
              <input :id="x" type="radio" :name="`quiz${i}`" />
              <label class="ml-2" :for="x">Option {{ x }}</label>
            </span>
          </div> -->
        </div>
      </div>
    </div>
  </container>
</template>
<script>
export default {
  components: {
    container: () => import("@/components/general/container"),
    LmsButton: () => import("@/components/general/button"),
  },
  data() {
    return {
      chartData: [
        ["Year", "Sales", "Expenses", "Profit"],
        ["2014", 1000, 400, 200],
        ["2015", 1170, 460, 250],
        ["2016", 660, 1120, 300],
        ["2017", 1030, 540, 350],
      ],
      chartOptions: {
        chart: {
          title: "Company Performance",
          subtitle: "Sales, Expenses, and Profit: 2014-2017",
        },
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.quiz {
  .navs {
    color: color(lms-tenant);
  }
  .description {
    h6 {
      color: color(lms-tenant);
    }
  }
  .question-head {
    color: color(lms-tenant);
  }
}
</style>
